import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Input, message, Modal, Radio, Rate, Space } from 'antd'
import './index.scss'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import BookingService from 'services/addBookingService'

export default function RatePopup({ isRate, setIsRate, detail, ratePoin, setRatePoin, showRate }) {
  const { data: user, isUserLoggedIn } = useSelector((state) => state.authReducer)
  const [form] = Form.useForm()
  const { t: translation } = useTranslation()
  const { TextArea } = Input
  const [submitForm, setSubmitForm] = useState(0)
  const [submitTextForm, setSubmitTextForm] = useState('')

  const onClose = () => {
    setIsRate(false)
    setSubmitForm(0)
  }

  const handleFormatHideUserName = (userName) => {
    if (userName) {
      const atIndex = 2
      if (atIndex !== -1) {
        const name = userName?.slice(0, atIndex)
        const showname = name?.slice(0, Math.min(name.length, 4))
        const hidden = '******'
        const domain = userName?.slice(-2)
        const hiddenName = showname + hidden + domain

        return hiddenName
      }
    } else {
      userName = ''
    }
    return userName
  }
  const onFinish = (value) => {
    const data = {
      stationsId: detail.stationsId,
      ratingPoint: ratePoin >= 1 ? ratePoin : 1,
      ratingType: 11,
      reviewContent: value.note || ''
    }
    BookingService.reviewStation(data).then((result) => {
      const { error: rsMess, statusCode } = result
      if (statusCode != 200) {
        if (rsMess == 'DUPLICATE_STATION_REVIEW') {
          message.warn(translation('DUPLICATE_STATION_REVIEW'))
          return
        } else return message.warn(translation('Err-retry'))
      } else {
        if (ratePoin <= 3) {
          setSubmitForm(1)
          setSubmitTextForm('thank-review1')
        } else {
          setSubmitForm(2)
          setSubmitTextForm('thank-review2')
        }
        message.success(translation('thank-rate'))
      }
    })
  }

  return (
    <Modal onCancel={onClose} placement="top" width={600} height={600} footer={null} open={isRate}>
      <>
        <div
          className={`review-header sticky-header d-flex ai-c j-sb`}
          style={{ backgroundColor: 'var(--primary-button-color)', borderColor: 'transparent', height: '50px' }}>
          <div className="d-flex ai-c mg-auto">
            <div style={{ color: 'white' }} className="title">
              {translation('Review-title')}
            </div>
          </div>
        </div>
        {showRate && (
          <div className="rate">
            <Rate
              className="rate-inpop"
              disabled={submitForm}
              onChange={(e) => {
                console.log('rate', e)
                setIsRate(true)
                setRatePoin(e)
              }}
              allowHalf
              defaultValue={5}
            />
          </div>
        )}

        {submitForm ? (
          <>
            <div className="w-100 d-flex justify-content-center mt-4 mb-3 text-small">{translation(submitTextForm)}</div>
            <Button
              className="login__button w-100 custom-df-btn light custom-btn"
              onClick={() => {
                onClose()
              }}
              style={{ marginTop: 8 }}
              size="large">
              {translation('Close')}
            </Button>
            {submitForm == 2 && (
              <Button
                className="login__button df mt-4 custom-default-btn"
                type="primary"
                onClick={() => {
                  window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(detail.stationsAddress)}`)
                }}
                size="large">
                {translation('share-ggmap')}
              </Button>
            )}
          </>
        ) : (
          <div className="container-review">
            <div style={{ marginTop: 10 }}>
              <Form
                layout="vertical"
                className="form-heigh-askadvice"
                name="login"
                autoComplete="new-password"
                initialValues={{}}
                form={form}
                onFinish={(values) => {
                  onFinish(values)
                }}>
                <p>
                  {translation('Station')}: {detail.stationsName}
                </p>
                <p>
                  {translation('user')}: {handleFormatHideUserName(user?.firstName)}
                </p>
                <Form.Item name="note" label={translation('Review-note')} className="mt-3" rules={[]}>
                  <TextArea className="login__input" placeholder={translation('Review-place')} type="text" size="large" rows={4} />
                </Form.Item>
                <div className="w-100 d-flex justify-content-center" style={{ gap: '0 20px' }}>
                  <Button className="login__button df mt-3 custom-default-btn" type="primary" htmlType="submit" size="large">
                    {translation('Review')}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </>
    </Modal>
  )
}
